export function convertFileFromUtf8WithBomToUtf8(
  _content: Buffer | string,
): string {
  const BOM = '\uFEFF';

  let content: string;
  if (typeof _content === 'string') {
    content = _content;
  } else {
    content = _content.toString('utf8');
  }

  const isBOM = content.startsWith(BOM);
  if (isBOM) {
    return content.slice(1);
  }
  return content;
}
